import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/mystery.svg'
import _imports_1 from '@/assets/images/icons/info_white.svg'
import _imports_2 from '@/assets/images/icons/mini_qr.svg'
import _imports_3 from '@/assets/images/icons/map-pin.svg'
import _imports_4 from '@/assets/images/icons/nft-info.svg'


const _hoisted_1 = {
  key: 0,
  class: "nft-card-back card-front"
}
const _hoisted_2 = { class: "card-line" }
const _hoisted_3 = { class: "tag-area" }
const _hoisted_4 = {
  key: 0,
  class: "tag-name"
}
const _hoisted_5 = {
  key: 1,
  class: "tag-name"
}
const _hoisted_6 = { class: "logo-area" }
const _hoisted_7 = {
  key: 0,
  class: "float-right-info"
}
const _hoisted_8 = { class: "nft-image mb-16" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "nft-status-image"
}
const _hoisted_11 = {
  key: 1,
  class: "nft-status-image nft-status-image-primary"
}
const _hoisted_12 = { class: "more-btn" }
const _hoisted_13 = {
  key: 2,
  class: "nft-status-image nft-status-image-gray"
}
const _hoisted_14 = {
  key: 3,
  class: "nft-status-image nft-status-image-red"
}
const _hoisted_15 = { class: "more-btn" }
const _hoisted_16 = {
  key: 4,
  class: "nft-status-image nft-status-image-fail"
}
const _hoisted_17 = {
  key: 5,
  class: "nft-status-image nft-status-image-fail"
}
const _hoisted_18 = {
  key: 6,
  class: "nft-status-image nft-status-image-qtnr"
}
const _hoisted_19 = { class: "desc-text" }
const _hoisted_20 = {
  key: 7,
  class: "nft-status-image nft-status-image-qtnr"
}
const _hoisted_21 = { class: "desc-text" }
const _hoisted_22 = {
  key: 8,
  class: "center-icon"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "name-area" }
const _hoisted_25 = { class: "offer-name" }
const _hoisted_26 = {
  key: 0,
  class: "nft-name"
}
const _hoisted_27 = { class: "fixed-info" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  class: "nft-card-back card-back"
}
const _hoisted_30 = { class: "card-line" }
const _hoisted_31 = { class: "logo-area" }
const _hoisted_32 = { class: "qr-row" }
const _hoisted_33 = {
  key: 0,
  class: "qr-image-area mb-8"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 1,
  class: "qr-status-area mb-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nft_line_svg = _resolveComponent("nft-line-svg")!
  const _component_MvButton = _resolveComponent("MvButton")!
  const _component_qr_status_comp = _resolveComponent("qr-status-comp")!
  const _component_pay_card_back = _resolveComponent("pay-card-back")!
  const _component_mmbs_card_back = _resolveComponent("mmbs-card-back")!
  const _component_ticket_card_back = _resolveComponent("ticket-card-back")!
  const _component_nft_card_info_comp = _resolveComponent("nft-card-info-comp")!
  const _component_bottom_slide_sheet = _resolveComponent("bottom-slide-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "nft-card-comp",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.flippCard && _ctx.flippCard(...args)))
    }, [
      _renderSlot(_ctx.$slots, "status"),
      _createElementVNode("div", {
        class: _normalizeClass(["nft-card-theme", _ctx.className])
      }, [
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_nft_line_svg, {
                  type: _ctx.data.cltnType,
                  color: _ctx.nftData.color
                }, null, 8, ["type", "color"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.disabledStatus)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(`nftCard.${_ctx.disabledStatus}`)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.nftData.tag)), 1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.nftData.grouping && !_ctx.onList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('nftCard.entry')) + ": " + _toDisplayString(_ctx.data.groupCount), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.nftData.image,
                  class: "nft-image-el"
                }, null, 8, _hoisted_9),
                (_ctx.nftData.status === 'SENDING')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('nftCard.sendingLogo')), 1))
                  : (_ctx.nftData.status === 'SELLING')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t('nftCard.selling')), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('common.more')), 1)
                      ]))
                    : (_ctx.nftData.status === 'SELL_REG')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('nftCard.regitSelling')), 1))
                      : (_ctx.nftData.status === 'SELL_REG_FAIL')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createTextVNode(_toDisplayString(_ctx.$t('nftCard.regitSellingFail')) + " ", 1),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('nftCard.solving')), 1)
                          ]))
                        : (_ctx.nftData.status === 'SEND_FAIL')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('nftCard.sendingFailed')), 1))
                          : (_ctx.nftData.status === 'FAIL')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('nftCard.failed')), 1))
                            : (_ctx.nftData.isWait)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _cache[7] || (_cache[7] = _createElementVNode("img", {
                                    src: _imports_0,
                                    class: "mystery-img"
                                  }, null, -1)),
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('nftCard.status.wait.required')), 1)
                                ]))
                              : (!_ctx.nftData.isQtnr && !_ctx.disabledStatus)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _cache[8] || (_cache[8] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('nftCard.status.qtnr.required')), 1),
                                    _createVNode(_component_MvButton, {
                                      text: _ctx.$t('nftCard.status.qtnr.submit'),
                                      type: "rec-primary",
                                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'NftQtnrView', params: {id: _ctx.nftData.id} })), ["stop"]))
                                    }, null, 8, ["text"])
                                  ]))
                                : _createCommentVNode("", true),
                (_ctx.centerIcon)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: _ctx.centerIcon.src,
                        class: _normalizeClass(_ctx.centerIcon.className)
                      }, null, 10, _hoisted_23)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.nftData.cltnName), 1),
                (_ctx.nftData.name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.nftData.name), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.data?.seat?.id)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.$t('nftCard.seat')) + ": " + _toDisplayString(_ctx.data?.seat?.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divider" }, null, -1)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-footer" }, [
                _createElementVNode("div", { class: "footer-qr-container" }, [
                  _createElementVNode("img", { src: _imports_2 })
                ])
              ], -1))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.flipLock)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_nft_line_svg, {
                  type: _ctx.data.cltnType,
                  color: _ctx.nftData.color
                }, null, 8, ["type", "color"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                (_ctx.data?.seat?.id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "float-seat-btn cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'NftSeatMapView', params: { id: _ctx.data.id } })), ["stop"]))
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("img", {
                        src: _imports_3,
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t('nftCard.seatMap')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.info)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "float-info-img cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.toggleModal(true)), ["stop"]))
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        alt: ""
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                (!_ctx.qrStatus && !_ctx.data.isQpass)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("img", {
                        src: _ctx.qrImage,
                        alt: "qr-code"
                      }, null, 8, _hoisted_34)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createVNode(_component_qr_status_comp, {
                        "nft-id": _ctx.data.id,
                        "is-qpass": _ctx.data.isQpass,
                        type: _ctx.data.cltnType,
                        status: _ctx.qrStatus,
                        "open-date": _ctx.data.openDate ? _ctx.data.openDate : _ctx.data?.attributes?.openDate,
                        "time-zone": _ctx.data?.attributes?.timeZone
                      }, null, 8, ["nft-id", "is-qpass", "type", "status", "open-date", "time-zone"])
                    ]))
              ]),
              (_ctx.data.type === 'PAY')
                ? (_openBlock(), _createBlock(_component_pay_card_back, {
                    key: 0,
                    "qr-image": _ctx.qrImage,
                    data: _ctx.data
                  }, null, 8, ["qr-image", "data"]))
                : (_ctx.data.cltnType === 'MEMBERSHIP' && !_ctx.isPreview)
                  ? (_openBlock(), _createBlock(_component_mmbs_card_back, {
                      key: 1,
                      "qr-image": _ctx.qrImage,
                      data: _ctx.data
                    }, null, 8, ["qr-image", "data"]))
                  : (_ctx.data.cltnType === 'TICKET')
                    ? (_openBlock(), _createBlock(_component_ticket_card_back, {
                        key: 2,
                        "qr-image": _ctx.qrImage,
                        data: _ctx.data
                      }, null, 8, ["qr-image", "data"]))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app-inner" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createBlock(_component_bottom_slide_sheet, {
            key: 0,
            visible: _ctx.isOpen,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isOpen) = $event)),
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
            "max-height": true
          }, {
            content: _withCtx(() => [
              _createVNode(_component_nft_card_info_comp, {
                data: _ctx.data,
                onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleModal(false))),
                "is-header": false
              }, null, 8, ["data"])
            ]),
            _: 1
          }, 8, ["visible"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}